// tslint:disable:no-object-literal-type-assertion
import { Spinner } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../../services/AnalyticsService';
import { ITranslateStore } from '../../../stores/TranslateStore';
import WarningNotice from '../notices/WarningNotice';

import UnsettledReceivablesStore from '../../../stores/UnsettledReceivablesStore';
import ClosableModal from './ClosableModal';
import MasterRefNumberPaymentModal from './MasterRefNumberPaymentModal';

interface IPayAllPaymentModalProps {
  unsettledReceivablesStore?: UnsettledReceivablesStore;
  translateStore?: ITranslateStore;
  analyticsService?: AnalyticsService;
}

@inject('unsettledReceivablesStore', 'translateStore', 'analyticsService')
@observer
export default class PayAllPaymentModal extends React.Component<IPayAllPaymentModalProps> {
  public componentDidMount(): void {
    this.props.unsettledReceivablesStore.tryLoadUnsettledReceivables();
  }

  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const analyticsService = this.props.analyticsService;

    if (this.props.unsettledReceivablesStore.unsettledReceivables.isInitialLoading) {
      return (
        <ClosableModal>
          <Spinner />
        </ClosableModal>
      );
    }

    if (this.props.unsettledReceivablesStore.unsettledReceivables.isFinishedWithError) {
      return (
        <ClosableModal>
          <WarningNotice translationKey="invoices.errors.failed-to-load-page" />
        </ClosableModal>
      );
    }

    return (
      <MasterRefNumberPaymentModal
        amount={this.props.unsettledReceivablesStore.totalAmountToPay}
        headingLabel={translate('shared.payment-modal.pay-invoices')}
        amountFieldLabel={translate('shared.payment-modal.to-pay')}
        onRedirectToBank={(banklinkName) => analyticsService.paymentModalPayAllInvoices(banklinkName)}
      />
    );
  }
}
